import { render, staticRenderFns } from "./MvtStockDetailsPopin.vue?vue&type=template&id=b31851b0&scoped=true"
import script from "./MvtStockDetailsPopin.vue?vue&type=script&lang=js"
export * from "./MvtStockDetailsPopin.vue?vue&type=script&lang=js"
import style0 from "./MvtStockDetailsPopin.vue?vue&type=style&index=0&id=b31851b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31851b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b31851b0')) {
      api.createRecord('b31851b0', component.options)
    } else {
      api.reload('b31851b0', component.options)
    }
    module.hot.accept("./MvtStockDetailsPopin.vue?vue&type=template&id=b31851b0&scoped=true", function () {
      api.rerender('b31851b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock/MvtStockDetailsPopin.vue"
export default component.exports